import React, { useState } from 'react';
import { Card, Button } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { getImageUrl } from '../utils/imageUtils';

const ProductOnLine = ({ product }) => {
  const { deviseInfo } = useSelector((state) => state.devise);
  const [imageError, setImageError] = useState(false);

  const currency =
    typeof deviseInfo === 'string' && deviseInfo !== '---' ? deviseInfo : 'TND';

  const getPrice = () => {
    if (currency === 'EUR' && product.priceEur != null) return `${product.priceEur} EUR`;
    if (currency === 'USD' && product.priceDol != null) return `${product.priceDol} USD`;
    return `${product.price ?? 0} TND`;
  };

  return (
    <Card className='product-card'>
      <Link to={`/product/online/${product._id}`} className='card-img-wrap d-block'>
        <span className='product-badge'>En ligne</span>
        <Card.Img
          className='product-image'
          src={imageError ? '/images/placeholder.jpg' : getImageUrl(product.image)}
          variant='top'
          onError={() => setImageError(true)}
        />
      </Link>

      <Card.Body>
        <Link to={`/product/online/${product._id}`}>
          <Card.Title className='product-title' as='div'>
            {product.name}
          </Card.Title>
        </Link>

        {product.description && (
          <p className='product-meta' style={{
            display: '-webkit-box',
            WebkitLineClamp: 2,
            WebkitBoxOrient: 'vertical',
            overflow: 'hidden',
          }}>
            {product.description}
          </p>
        )}

        <div className='product-price'>{getPrice()}</div>

        <div className='product-cta'>
          <Link to={`/product/online/${product._id}`} className='d-grid'>
            <Button className='btn-teal btn-sm'>Voir les détails</Button>
          </Link>
        </div>
      </Card.Body>
    </Card>
  );
};

export default ProductOnLine;
